import { FormGroup } from '@angular/forms';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FieldType } from 'ng-formly';

@Component({
	selector: 'formly-repeat-section',
	template: `  
		<div class="card">
			<div class="card-header">
				<strong>{{field?.fieldArray?.templateOptions?.label}}</strong>
				<button *ngIf='!viewMode && field && field.fieldArray && field.fieldArray.templateOptions 
				&& field.fieldArray.templateOptions.btnText' class="btn btn-primary btn-sm pull-right" (click)="add()">
				{{field?.fieldArray?.templateOptions?.btnText}}</button>
			</div>
			<div class="card-block">
				<div *ngFor="let control of formControl['controls']; let i = index;" class="row" style="border-bottom:1px solid #eeeeee">   
					<div class="col-xs-11" style="padding-top:5px;">
						<formly-form         
						[model]="model[i]"
						[fields]="fields(i)"
						[form]="control"
						[options]="newOptions"
						[ngClass]="field.fieldArray.className">
						</formly-form> 
					</div>
					<div *ngIf="!viewMode" class="col-xs-1">
						<button class="btn btn-danger btn-sm" style="margin-top:25px;margin-left:25px;" (click)="remove(i)">x {{i+1}}</button>
					</div>
				</div>
			</div>
		</div>
  `,
})
export class RepeatComponent extends FieldType implements OnInit, OnDestroy {

	_fields = [];

	_newOptions: any;

	get viewMode() {
		return this.form['viewMode'] || false;
	}

	get newOptions() {
		if (!this._newOptions) {
			this._newOptions = this.options ? JSON.parse(JSON.stringify(this.options)) : {};
		}
		return this._newOptions;
	}

	ngOnInit() {
		if (!this.form['newcontrols']) {
			this.form['newcontrols'] = {};
		}
		for (let key in this.form.controls) {
			if (this.form.contains.hasOwnProperty(key)) {
				this.form['newcontrols'][key] = this.form.controls[key];
			}
		}
		this.setNewFormControl(this.key);

		if (this.formControl['controls']) {
			this.formControl['controls'].splice(0, this.formControl['controls'].length);
		} else {
			this.formControl['controls'] = [];
		}

		if (this.model) {
			this.model.map((m, index) => {
				this.formControl['controls'].push(new FormGroup({}));
				this._fields.push(this.getFormGroup(index));
			});
		}
	}

	add() {
		this.formControl['controls'].push(new FormGroup({}));
		let index = this.model.length;
		this.model.push({});
		this._fields.push(this.getFormGroup(index));
	}

	remove(i) {
		this.formControl['controls'].splice(i, 1);
		this.model.splice(i, 1);
		this._fields.splice(i, 1);
	}

	fields(i) {
		if (this._fields[i]) {
			return this._fields[i];
		}

		this._fields.splice(i, 0, this.getFormGroup(i));
		return this._fields[i];
	}

	private getFormGroup(index) {
		let fg = JSON.parse(JSON.stringify(this.field.fieldArray.fieldGroup));
		if (this.to.parentmodel) {
			fg.forEach(fg1 => {
				if (fg1.type === 'repeatedsection') {
					fg1.templateOptions = fg1.templateOptions || {};
					fg1.templateOptions['grandparentmodel'] = this.to.parentmodel;
					fg1.templateOptions['parentmodel'] = this.model[index];
				} else { fg1.templateOptions['parentmodel'] = this.to.parentmodel; }
			});
		}
		if (this.to.grandparentmodel) { fg.forEach(fg1 => { fg1.templateOptions['grandparentmodel'] = this.to.grandparentmodel; }); }
		return fg;
	}

	private setNewFormControl(fieldname: string) {
		if (this.form['newcontrols'][fieldname]) {
			if (!this.form.controls[fieldname]) {
				this.form.addControl(fieldname, this.form['newcontrols'][fieldname]);
			} else {
				this.form.setControl(fieldname, this.form['newcontrols'][fieldname]);
			}
		} else {
			console.log('Error !!! No Form Control for Field: "' + fieldname + '" in input-field of "' + this.key + '"');
		}
	}

	ngOnDestroy() { }
}







// WEBPACK FOOTER //
// ./src/app/shared/components/fields/repeatedsection.ts